import React from "react"
import PropTypes from "prop-types"
import {
  SettingsBlock,
  SettingsBlockContent,
  SettingsCardSection,
} from "@modules/site/settings"
import Loading from "@modules/ui/components/Loading"
import { CmsIntegrationRow } from "./CmsIntegrationRow"
import { useCmsIntegrationControls } from "../hooks/useCmsIntegrationControls"
import { ErrorAlert } from "@modules/ui/components/ErrorAlert"

function CmsIntegrationContent({
  loading,
  error,
  cmsIntegrations,
  siteId,
  orgSiteName,
  permissionToEdit,
}) {
  const {
    setCmsToEdit,
    setCmsToRemove,
    controlModals,
  } = useCmsIntegrationControls(siteId, orgSiteName)

  if (loading) {
    return (
      <Loading
        delay={1000}
        message="loading available cms integrations..."
        bufferSize="none"
      />
    )
  }

  if (error) {
    return (
      <SettingsCardSection applyPaddingTop={false}>
        <ErrorAlert>{error.message}</ErrorAlert>
      </SettingsCardSection>
    )
  }

  if (cmsIntegrations.length === 0) {
    return <p>No integrations</p>
  }

  return (
    <React.Fragment>
      {cmsIntegrations.map(cmsIntegration => {
        return (
          <CmsIntegrationRow
            key={cmsIntegration.name}
            cms={cmsIntegration}
            editable={permissionToEdit}
            onEdit={() => setCmsToEdit(cmsIntegration)}
            onDelete={() => setCmsToRemove(cmsIntegration)}
          />
        )
      })}

      {controlModals}
    </React.Fragment>
  )
}

export function CmsIntegrationCard({
  loading,
  error,
  cmsIntegrations = [],
  title,
  docUrl,
  linkLabel,
  siteId,
  orgSiteName,
  permissionToEdit = true,
  integrationsBlockId,
  children,
}) {
  return (
    <SettingsBlock
      data-cy={`settings-block-${title.replace(/\s/g, ``).toLowerCase()}`}
      title={title}
      docUrl={docUrl}
      id={integrationsBlockId}
    >
      <SettingsBlockContent>
        <CmsIntegrationContent
          loading={loading}
          error={error}
          cmsIntegrations={cmsIntegrations}
          siteId={siteId}
          orgSiteName={orgSiteName}
          permissionToEdit={permissionToEdit}
          linkLabel={linkLabel}
          title={title}
        />
        {children}
      </SettingsBlockContent>
    </SettingsBlock>
  )
}

CmsIntegrationCard.propTypes = {
  siteId: PropTypes.string,
  cmsIntegration: PropTypes.array,
  error: PropTypes.bool,
  loading: PropTypes.bool,
  title: PropTypes.string,
  docUrl: PropTypes.string,
  linkLabel: PropTypes.string,
  orgSiteName: PropTypes.string,
  permissionToEdit: PropTypes.bool,
}
